export default __webpack_public_path__ + "static/media/masiau1.ac851296.jpg";